<template>
  <div class="list-wrapper">
    <div
      v-for="team in teams"
      :key="team.teamId"
      class="team-container"
    >
      <team-icon
        class="icon"
        :team="team"
      />
      <p class="name">
        {{ team.name }}
      </p>
      
      <div class="content">
        <div class="deadline">
          <label>{{ $t('deadline') }}</label>
          <div>
            Submit your work schedule every
            <span>{{ team.settings['submit-deadline-day'] }}</span> at 
            <span>{{ formatHour(team.settings['submit-deadline-time']) }}</span>, 
            <span>{{ team.settings['timezone'] }}</span> time.
          </div>
        </div>
        <!-- <dropdown
          class="day dropdown"
          :title="$t('day')"
          :options="weekdays(weekdays().findIndex(x=>x.value === weekStart))"
          :team-id="team.teamId"
          dbname="submit-deadline-day"
          :value="team.settings['submit-deadline-day']"
          :disabled="disabled"
          @saved-to-db="savedToDb"
        />
        <dropdown
          class="time dropdown"
          :title="$t('time')"
          :options="hours"
          by-value
          :team-id="team.teamId"
          dbname="submit-deadline-time"
          :value="team.settings['submit-deadline-time']"
          :disabled="disabled"
          @saved-to-db="savedToDb"
        />
        <dropdown
          class="time-zone dropdown"
          editable
          auto-complete
          :title="$t('timeZone')"
          by-value
          :options="timezones"
          :team-id="team.teamId"
          dbname="timezone"
          :value="team.settings['timezone']"
          :disabled="disabled"
          @input="changeTimezone"
        /> -->
        <div class="holidays">
          <editable-input
            v-if="!singleTeam"
            v-model="teamsLimits[team.teamId]"
            :title="$t('annualPaidLeave')"
            :placeholder="$t('egX',{x: '20'})"
            input-type="number"
            :incorrect-value-msg="$t('incorrectNumerical')"
            :validation-function="positiveNumberValid"
            :restore-value-on-incorrect="true"
            class="h-input"
            @focus-out="changeVacationDays(team)"
          />
          <p>{{ $t('daysPerYear') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Parse from 'parse'
import Color from '@/components/Color'
import Constants from '@/components/Constants'
import TeamIcon from '@/components/Team/TeamIcon'
import ParseFunctions from '@/components/ParseFunctions';
import Validation from '@/components/Validation'
import EditableInput from '@/components/UI/EditableInput'
import moment from 'moment-timezone'

export default {
  components: {
    TeamIcon,
    EditableInput,
  },
  mixins: [Color, Validation, Constants, ParseFunctions],
  props: {
    //initialSetting: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
    is24h: {
      type: Boolean,
      default: true,
    },
    singleTeam: Object,
    userSettings: Object
  },
  data() {
    return {
      teamIconURL: '',
      timezones: null,
      timezonesLoaded: false,
      teamsLimits: {},
    }
  },
  computed: {
    weekStart: function() {
      return this.userSettings['week-start'] || 'Monday'
    },
    teams: function() {
      if (this.singleTeam) {
        return [this.singleTeam]
      } else {
        return this.$store.state.teams
      }
    },
    hours : function(){
      return this.hoursFormatWithFractions(this.userSettings['is-24h'], 2)
    }
  },    
  async created() {

    this.timezones = this.$store.state.timezonesGlobal
    this.timezonesLoaded = true
    this.teamsLimits = this.formatHolidayInfo(this.$store.state.holidayInfo[Parse.User.current()._getId()].holidayInfo)

  },
  methods: {
    async savedToDb(teamId, name, value) {
      await this.$store.dispatch('reloadTeams')
      let t = await this.getTeamById(teamId)
      // console.log(t)
      if (t) {
        t.settings[name] = value
        if(this.singleTeam){
          this.singleTeam.settings[name] = value
        }
      } else {
        console.error('teamId from dropdown mismatch')
      }
    },
    async changeTimezone(value){
      this.singleTeam.settings.timezone = value
    },
    async changeVacationDays(team){
      let res = await this.getMyTeamMemberId(team.teamId)
      if(res.status === 'ok'){
        let teamMemberId = res.teamMemberId
        let year = moment().format('YYYY')
        res = await this.setHolidayDays(teamMemberId, year, this.teamsLimits[team.teamId])
        if(res.status === 'ok'){
          this.$store.commit('updateHolidayInfo', {userId: Parse.User.current()._getId(), teamId: team.teamId, year: year, limit: this.teamsLimits[team.teamId]})
        } else {
          this.showServerError(res)
        }
      }
      else{
        this.showServerError(res)
      }
    },
    formatHour(deadline) {
      return this.is24h ? deadline : moment(deadline, ['HH:mm']).format('h:mm A')
    },
    formatHolidayInfo(teams) {
      let formattedHolidayInfo = {}
      let year = moment().format('YYYY')
      for (const team of teams) {
        let limit = team.holiday[year].limit
        formattedHolidayInfo[team.teamId] = limit
      }
      return formattedHolidayInfo
    },
  },
}
</script>

<style lang="scss" scoped>

.team-container {
  display: grid;
  grid-template-columns: 30px auto;
  column-gap: 20px;
  grid-template-rows: 30px auto 24px auto;
  align-items: center;

  margin-bottom: 60px;

  @include respond-below(sm) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .icon {
    grid-row: 1;
    grid-column: 1;

    transform: scale(1.4);
    transform-origin: center left;
    @include respond-below(sm) {
      margin-bottom: 18px;
    }
    
  }
  .name {
    grid-row: 1;
    grid-column: 2;

    font-size: 16px;
    line-height: 16px;
    letter-spacing: 0.2px;
    font-family: $bold;
    vertical-align: middle;
    grid-column-start: 2;

    @include respond-below(sm) {
      margin-bottom: 24px;
    }
  }

  .content {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-column-gap: 8%;
    grid-row-gap: 36px;

    grid-row: 4;
    grid-column: 2;

    @include respond-below(sm) {
      display: flex;
      flex-direction: column;
    }

    .deadline {
      grid-column: span 3;
      label {
        @include label;
      }
      div {
        color: $amethyst;
        margin-top: 6px;
        font-size: 14px;
        line-height: 24px;
        span {
          color: $black;
          // font-family: $bold;
        }
      }
    }

    .holidays {
      grid-column: span 3;
      display: flex;
      .h-input {
        width: 220px;
      }
      p {
        align-self: flex-start;
        margin-top: 32px;
        margin-bottom: 12px;
        margin-left: 12px;
      }
    }
  }


  // .day {
  //   grid-row: 2;
  //   grid-column: 1;
  //   position: relative;
  //   &::after {
  //     display: block;
  //     position: absolute;
  //     right: -38px;
  //     top: 22px;
  //     content: 'at';
  //     font-family: $regular;
  //     font-size: 14px;
  //     line-height: 40px;
  //     color: $bluebell;
  //     // transform: scale(-50%, -50%);
  //   }
  // }
  // .time {
  //   grid-row: 2;
  //   grid-column: 2;
  // }
  // .time-zone {
  //   grid-row: 2;
  //   grid-column: 3;
  // }
}


</style>
